import React from 'react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
export function Urgency() {
  return <section className="w-full bg-navy-900 px-4 py-16 text-white sm:py-20" aria-labelledby="urgency-heading" data-id="element-324" data-mp="2fjiku7hbfivj">
      <div className="mx-auto max-w-2xl text-center" data-id="element-325" data-mp="2bjqiwdmfgaz5">
        <p className="font-display text-sm font-extrabold uppercase tracking-widest text-gold-300" data-id="element-326" data-mp="26l5iad39jpa6">Special offer</p>
        <h2 id="urgency-heading" className="mt-3 font-display text-[1.7rem] font-black leading-tight sm:text-4xl" data-id="element-327" data-mp="339cukg6c8rbk">
          Don’t Miss the Opportunity to Build a More Structured Smile Design Workflow.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-white/80" data-id="element-328" data-mp="2ugrr07ba2r7b">
          Instead of continuing to search through disconnected resources, start learning from a clearly organized collection of aesthetic planning references.
        </p>
        <div className="mt-8" data-id="element-329" data-mp="3i7x6gldb3hh3">
          <CountdownTimer data-id="element-330" data-mp="3i6vtgbcqckwq" />
        </div>
        <div className="mt-8" data-id="element-331" data-mp="3i5u4d2yvpxw0">
          <CTAButton label="Get Smile Design Roadmap™ for $27" sublabel="Before the timer runs out" data-id="element-332" data-mp="k0gqpm02gcqs" />
        </div>
      </div>
    </section>;
}